import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]冷启动
 */
export function coldStartUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultRecommendFundVo> {
  return resource.postNoAuth('/recommendFund/coldStart', req, config);
}

/**
 * 查询持仓推荐基金列表--已废弃
 */
export function queryUsingPOST_1(
  req: HoldRecommendQuery | void,
  config?: RequestConfig
): Promise<ApiResultRecommendFundResponse> {
  return resource.post('/recommendFund/query', req, config);
}

/**
 * 根据客户号获取持仓推荐基金列表
 */
export function queryByClientIdUsingPOST(
  req: HoldRecommendQuery | void,
  config?: RequestConfig
): Promise<ApiResultRecommendFundVo> {
  return resource.post('/recommendFund/queryByClientId', req, config);
}

/**
 * [No Auth]根据手机号获取持仓推荐基金列表
 */
export function queryByPhoneUsingPOST(req: PhoneDto, config?: RequestConfig): Promise<ApiResultRecommendFundVo> {
  return resource.postNoAuth('/recommendFund/queryByPhone', req, config);
}
